import { Merchant } from "../sales/merchant";
import { Product } from "./product";
import { Warehouse } from "./warehouse";


export enum MovementType {
  MovementTypeIn = "IN",
  MovementTypeOut = "OUT",
  MovementTypeTransfer = "TRANSFER",
  MovementTypeAdjust = "ADJUST",
}
export interface StockMovement {
  id: string;
  date: Date;
  description?: string | null;
  product_id: string;
  product?: Product;
  source_warehouse_id?: string;
  warehouse_id: string;
  warehouse?: Warehouse;
  merchant_id?: string | null;
  merchant?: Merchant| null;
  distributor_id?: string | null;
  company_id?: string | null;
  quantity: number;
  type: MovementType;
  reference_id?: string | null;
}
